import { Blockquote, H1, H2, H3, P, Strong } from '../Prose';
export default function SectionQaReleasingToUsers() {
  return (
    <>
      <P>QA &amp; Release Management</P>
      <H1>Releasing to Users</H1>

      <H2>Pre-requisites</H2>

      <P>
        Before submitting a new release to the app stores, make sure all the
        necessary pre-requisites have been met.
      </P>

      <H3>QA passed</H3>

      <P>
        Someone at M10c must have approved the build you're planning on
        submitting. This will show under the Releases by as "QA Status":
        "Approved" on the build.
      </P>

      <H3>Build not superseded</H3>

      <P>
        If the build has been superseded by a more recent build (in which case
        it would show in the Builds list with a grey bar on the left), then the
        older build is no longer appropriate to relaese to users.
      </P>

      <H3>Client approved</H3>

      <P>
        Unless agreed with the Account Manager that the release can bypass
        client approval (e.g. small changes or urgent bugfix), the client should
        have a chance to test and approve each release themselves (by pressing
        the "Approve this release" button at the top of the page) before it goes
        live.
      </P>

      <P>
        You will need to notify the client that their testing is required, using
        the email template below. This should only be sent to the single contact
        who is responsible for testing releases.
      </P>

      <Blockquote>
        <P>Subject: [App Name] v[1.0.0] Ready for Testing and Approval</P>

        <P>Hi [First Name],</P>

        <P>
          I'm pleased to inform you that the latest version of [App Name],
          v[1.0.0], is ready for testing and approval. You can find the
          changelog and links to the builds here: [Direct link to release]
        </P>

        <P>
          We have finished our internal QA testing, so this is the final step.
        </P>

        <P>
          Once you have confirmed you're happy for the release to go live,
          please press the <Strong>Approve this release to go live</Strong>{' '}
          button at the top of the linked page.
        </P>

        <P>
          [If client is providing release notes:] Please remember that you'll
          also need to provide <Strong>Release Notes</Strong> that will be shown
          to users in the App Store highlighting what's new in this version. You
          can also do this from the linked page.
        </P>

        <P>
          Alternatively, if you have any questions, issues or concerns with the
          release, please don't hesitate to let me know by replying to this
          email.
        </P>
      </Blockquote>

      <P>
        Emails for when this button is pressed are{' '}
        <Strong>not yet automated</Strong> so you'll need to check back
        regularly.
      </P>

      <H3>Release Notes</H3>

      <P>
        Release Notes are required before an app can be submitted on iOS
        ("What's New in this Version"). Android doesn't require these, and we
        don't fill them in there, so technically the release could be made there
        first, but normally for simplicity it's easier to wait until Release
        Notes are ready and submit both at the same time.
      </P>

      <P>
        If we are providing Release Notes, the Account Manager should have
        filled these in on the Release page.
      </P>

      <P>
        On clients where we have agreed that they are providing the Release
        Notes (i.e. they care a lot about how new versions are presented to
        users), we they will need to fill this in. If the release is ready but
        they haven't provided them, you can use this email template to chase the
        main contact:
      </P>

      <Blockquote>
        <P>Subject: Request for Release Notes for [App Name] v[1.0.0]</P>
        <P>Hi [First Name],</P>
        <P>
          I am writing to follow up on the public release notes for the latest
          version of [App Name].
        </P>
        <P>
          As you are aware, public release notes are required by Apple's App
          Store. They give your users transparency into the changes and
          improvements in your latest app version.
        </P>
        <P>
          However, we have not yet received the public release notes for the
          latest version. As a result, we are unable to proceed with the app
          release process.
        </P>
        <P>
          I kindly request that you{' '}
          <Strong>provide us with the public release notes</Strong> as soon as
          possible, by visiting the following link and pressing the Edit button
          next to the "Release Notes" heading: [Direct link to release]
        </P>
        <P>
          If you are experiencing any difficulties or require additional
          information, please do not hesitate to contact us.
        </P>
      </Blockquote>
    </>
  );
}
